import { CareerPathScoreSection } from '@backrs_ui/common-ui';

import { createApi } from '@reduxjs/toolkit/query/react';

import { lubavAppBaseQuery, lubavAppBaseQueryWithCustomToken } from '../baseQuery';

type ExplainCareerPathFitRequest = Readonly<{
  career_path_id: number;
  response_set_id: string;
  ranking: CareerPathScoreSection;
}>;

export const careerPathLubavApi = createApi({
  reducerPath: 'careerPathLubavApi',
  baseQuery: lubavAppBaseQuery,
  keepUnusedDataFor: 60 * 60 * 24 * 7, // Cache for 7 days (in seconds)
  endpoints: (build) => ({
    explainCareerPathFit: build.mutation<
      string,
      ExplainCareerPathFitRequest & { accessToken: string; onChunk?: (chunk: string) => void }
    >({
      queryFn: async ({ onChunk, accessToken, ...body }, _queryApi, _extraOptions) => {
        const customBaseQuery = lubavAppBaseQueryWithCustomToken(accessToken);

        const result = await customBaseQuery(
          {
            url: '/api/generate/career-path/explain-career-path-fit',
            method: 'POST',
            body,
            responseHandler: async (response) => {
              const reader = response.body?.getReader();
              const decoder = new TextDecoder();

              if (!reader) return '';

              let streamResult = '';

              while (true) {
                const { done, value } = await reader.read();

                if (done) break;

                const chunk = decoder.decode(value);

                streamResult += chunk;
                onChunk?.(streamResult);
              }

              return streamResult;
            },
          },
          _queryApi,
          _extraOptions,
        );

        if (result.error) {
          return { error: result.error };
        }

        return { data: result.data as string };
      },
    }),
  }),
});

export const { useExplainCareerPathFitMutation } = careerPathLubavApi;
